// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { AccessLogsListComponent } from 'src/app/modules/access-logs/pages/access-logs-list/access-logs-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: AccessLogsListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadAccessLogsList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AccessLogsRoutingModule { }
